import { render, staticRenderFns } from "./PersonalDataTab.vue?vue&type=template&id=db21195a"
import script from "./PersonalDataTab.vue?vue&type=script&lang=ts"
export * from "./PersonalDataTab.vue?vue&type=script&lang=ts"
import style0 from "./PersonalDataTab.vue?vue&type=style&index=0&id=db21195a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports